import { connect } from "react-redux";
import { actions } from "../../../../../redux/modules/reportes/caja";
import ListadoCaja from "./ListadoCaja";

const ms2p = (state) => {
    return {
        ...state.reporte_caja,
        usuario: state.usuario.me,
        sucursal_param: state.usuario.sucursal,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ListadoCaja);
